import React from "react";
import { Search } from "../../components/Search/Search";
import { SearchResults } from "../../components/SearchResults/SearchResults";
import { LastOperations } from "./components/LastOperations/LastOperations";
import { WarehouseStats } from "./components/WarehouseStats/WarehouseStats";
import { Fab } from "../../components/Fab/Fab";
import { view } from "../../lib/vvm";
import Logo from "../../components/Logo/Logo";
import Icon, { IconSize } from "../../components/Icon/Icon";
import styles from "./Main.module.css";
import { MainViewModel } from "./MainViewModel";

interface MainProps {}

export const Main: React.FC<MainProps> = view(MainViewModel)(({
  viewModel: {
    isSearch,
    events,
    realtimeStatus,
    realtimeStatusTone,
    showRealtimeReconnectAction,
    canReconnectRealtime,
    reconnectCooldownSeconds,
    operationsError,
    isOperationsLoading,
    warehouseStats,
    warehouseAdminSummary,
    isAdmin,
    pendingUsersCount,
    isWarehouseStatsLoading,
    warehouseStatsError,
    refreshDashboard,
    openStatsList,
    reconnectRealtime,
    openEvent,
    toQR,
    toQRManagement,
    toJournal,
    toAddPage,
    toAddBox,
    toAccount,
    toSettings,
    toUsersManagement,
    toDeletedEntities,
    isMenuOpen,
    menuRef,
    toggleMenu,
    onMenuAction,
    logoutFromMenu,
    isLoggingOut,
  },
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.quickMenu} ref={menuRef}>
        <button
          type="button"
          className={styles.quickMenuToggle}
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-haspopup="menu"
          aria-controls="main-actions-menu"
        >
          <Icon name={"Dots"} size={IconSize.large} />
          меню
        </button>
        {isMenuOpen && (
          <div
            className={styles.quickMenuList}
            role="menu"
            id="main-actions-menu"
            aria-label="Основные действия"
          >
            <button
              type="button"
              className={styles.quickMenuItem}
              role="menuitem"
              onClick={() => onMenuAction(toQRManagement)}
            >
              <Icon name={"Cards"} size={IconSize.medium} />
              QR-коды
            </button>
            <button
              type="button"
              className={styles.quickMenuItem}
              role="menuitem"
              onClick={() => onMenuAction(toJournal)}
            >
              <Icon name={"Book"} size={IconSize.medium} />
              журнал
            </button>
            <button
              type="button"
              className={styles.quickMenuItem}
              role="menuitem"
              onClick={() => onMenuAction(toAddPage)}
            >
              <Icon name={"Plus"} size={IconSize.medium} />
              товар
            </button>
            <button
              type="button"
              className={styles.quickMenuItem}
              role="menuitem"
              onClick={() => onMenuAction(toAccount)}
            >
              <Icon name={"Profile"} size={IconSize.medium} />
              аккаунт
            </button>
            <button
              type="button"
              className={styles.quickMenuItem}
              role="menuitem"
              onClick={() => onMenuAction(toSettings)}
            >
              <Icon name={"Settings"} size={IconSize.medium} />
              настройки
            </button>
            <button
              type="button"
              className={styles.quickMenuItem}
              role="menuitem"
              onClick={() => onMenuAction(toAddBox)}
            >
              <Icon name={"Bag"} size={IconSize.medium} />
              коробка
            </button>
            {isAdmin && (
              <button
                type="button"
                className={styles.quickMenuItem}
                role="menuitem"
                onClick={() => onMenuAction(toUsersManagement)}
              >
                <Icon name={"Users"} size={IconSize.medium} />
                <span className={styles.quickMenuItemLabel}>пользователи</span>
                {pendingUsersCount > 0 ? (
                  <span
                    className={styles.quickMenuPendingBadge}
                    aria-label={`Ожидают одобрения: ${pendingUsersCount}`}
                  >
                    !
                  </span>
                ) : null}
              </button>
            )}
            {isAdmin && (
              <button
                type="button"
                className={styles.quickMenuItem}
                role="menuitem"
                onClick={() => onMenuAction(toDeletedEntities)}
              >
                <Icon name={"Delete"} size={IconSize.medium} />
                <span className={styles.quickMenuItemLabel}>удаленные</span>
              </button>
            )}
            <button
              type="button"
              className={`${styles.quickMenuItem} ${styles.quickMenuItemDanger}`}
              role="menuitem"
              onClick={logoutFromMenu}
              disabled={isLoggingOut}
            >
              <Icon name={"Exit"} size={IconSize.medium} />
              {isLoggingOut ? "выход..." : "выйти"}
            </button>
          </div>
        )}
      </div>
      <div
        className={`${styles.topRow} ${isSearch ? styles.topRowSearchOnly : ""}`}
      >
        {!isSearch && (
          <div className={styles.brandColumn}>
            <Logo />
          </div>
        )}
        <div className={styles.searchColumn}>
          <Search />
        </div>
      </div>
      {isSearch ? (
        <SearchResults />
      ) : (
        <div className={styles.dashboard}>
          <WarehouseStats
            stats={warehouseStats}
            isAdmin={isAdmin}
            adminSummary={warehouseAdminSummary}
            isLoading={isWarehouseStatsLoading}
            error={warehouseStatsError}
            onRefresh={() => void refreshDashboard()}
            onOpenList={openStatsList}
          />
          <LastOperations
            events={events}
            status={realtimeStatus}
            statusTone={realtimeStatusTone}
            error={operationsError}
            isLoading={isOperationsLoading}
            showReconnectAction={showRealtimeReconnectAction}
            canReconnect={canReconnectRealtime}
            reconnectCooldownSeconds={reconnectCooldownSeconds}
            onReconnect={reconnectRealtime}
            onOpenEvent={(event) => void openEvent(event)}
          />
        </div>
      )}
      <div className={styles.buttons}>
        <Fab onClick={toQR} iconName={"QR"} label={"поиск по QR"} />
      </div>
    </div>
  );
});
